module.exports = __webpack_public_path__ + "static/media/mtn.f9ed4fe6.svg";